
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Locate } from "lucide-react";
import { IconButton } from "@/components/v2n/Button";
import { Navbar } from "@/components/v2n/Navbar";
import UsefulServicesHomepageInjector from "../components/UsefulServicesHomepageInjector";
import LanguageSelector from "../components/LanguageSelector";

export default function MainLayout({ children }) {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isGolfPlanner = ["/vibe2golf", "/vibe2day/golf"].includes(pathname.replace(/\/+$/, ""));

  if (pathname === "/admin" || pathname.startsWith("/admin/")) return <main>{children}</main>;

  return (
    <>
      <Navbar
        className={(pathname === "/admin" || pathname.startsWith("/admin/")) ? "visibility-navbar" : undefined}
        onMenu={() => setMenuOpen(true)}
        rightSlot={
          <>
            <LanguageSelector compact />
            {!isGolfPlanner && <IconButton
              onClick={() => window.location.reload()}
              aria-label="Use my location"
            >
              <Locate size={18} />
            </IconButton>}
          </>
        }
      />

      {/* Drawer */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50"
          onClick={() => setMenuOpen(false)}
        >
          <div
            className="absolute left-0 top-0 h-full w-72 bg-background-deep/95 backdrop-blur-2xl border-r border-white/10 shadow-[0_0_40px_rgba(0,0,0,0.5)] p-5 animate-slideIn"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setMenuOpen(false)}
              className="mb-5 flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-white hover:bg-white/10 transition"
            >
              ✕ Close
            </button>

            <div className="mb-6 border-b border-white/10 pb-5">
              <p className="text-xs uppercase tracking-[0.3em] text-fuchsia-400 mb-2">
                Explore Tonight
              </p>

              <h2 className="text-2xl font-black text-white">
                VIBE2NITE
              </h2>

              <p className="text-white/40 text-sm mt-2">
                Live nightlife discovery.
              </p>
            </div>

            <nav className="flex flex-col gap-3 text-white mt-6">
              <a href="/tonight-benalmadena" className="min-h-[44px] rounded-2xl border border-white/10 px-4 py-3">What's On · Benalmádena</a>
              <a href="/tonight-torremolinos" className="min-h-[44px] rounded-2xl border border-white/10 px-4 py-3">What's On · Torremolinos</a>

              <a
                href="/explore"
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                🔥 Trending Tonight
              </a>

              <a
                href="/map"
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                🗺️ Live Map
              </a>
              
              <a
                href="/venues"
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                 Venues
                </a>

              <a
                href="/vibe2golf"
                className="rounded-2xl border border-amber-200/25 bg-amber-200/5 px-4 py-3 text-white transition hover:border-amber-200/50 hover:bg-amber-200/10"
              >
                Vibe2Golf <span className="ml-1 text-xs text-amber-100">Beta · Vibe2Day</span>
              </a>

              <a
                href="/useful-services"
                className="rounded-2xl border border-cyan-300/20 bg-cyan-300/5 px-4 py-3 text-white hover:bg-cyan-300/15 hover:border-cyan-300/35 hover:shadow-[0_0_20px_rgba(0,245,255,0.18)] transition-all duration-300"
              >
                🧭 Useful Services
              </a>
              
              <a
                href="/favourites"
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                ⭐ Favourites
              </a>

              <a
                href="/me"
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                👤 Profile
              </a>

              <a
                href="/owner"
                className="rounded-2xl border border-fuchsia-500/20 bg-fuchsia-500/5 px-4 py-3 text-white hover:bg-fuchsia-500/15 hover:border-fuchsia-400/30 hover:shadow-[0_0_20px_rgba(255,0,200,0.2)] transition-all duration-300"
              >
                🏢 Venue Owner
              </a>

              <a
                href="/admin"
                className="rounded-2xl border border-red-500/20 bg-red-500/5 px-4 py-3 text-white hover:bg-red-500/15 hover:border-red-400/30 transition-all duration-300"
              >
                ⚙️ Admin
              </a>

            </nav>
          </div>
        </div>
      )}

      <main>{children}</main>
      <UsefulServicesHomepageInjector />
    </>
  );
}
